import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";

export const CellIconContainer = styled(IconButton)(
  ({ theme }) => `
  position: absolute;
  top: 1px;
  right: -10px;

  background: ${theme.palette.background.paper};
  border: 1px solid ${theme.palette.divider};

  :hover {
    background: ${theme.palette.background.paper};
  }

  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`
);

export const CellContainer = styled("div")(
  () => `
  position: relative;
  width: 100%;

  cursor: pointer;
`
);
